import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import store from './store';
import theme from './providers/MuiThemeProvider';
import { StyledEngineProvider } from '@mui/material/styles';
import App from './containers/App/App';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import moment from 'moment-timezone';
import { enableMapSet } from 'immer';

enableMapSet();

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>
            <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
              <App />
            </LocalizationProvider>
          </StyledEngineProvider>
        </ThemeProvider>
      </BrowserRouter>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
